var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStellarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.4772 0 0 4.4772 0 10C0 15.5228 4.4772 20 10 20C15.5228 20 20 15.5228 20 10C20 4.4772 15.5228 0 10 0ZM17.2222 8.19L16.6967 8.4578C16.2972 8.66167 16.0595 9.085 16.0933 9.53227C16.105 9.68727 16.1111 9.84447 16.1111 10.0011C16.1106 11.2906 15.7028 12.5467 14.9456 13.5895C12.9623 16.3211 9.14113 16.9278 6.40947 14.9445L7.48893 14.3945L7.55007 14.3623C8.29673 14.7811 9.13787 15.0011 9.99393 15.0017C12.7573 15.0034 14.9984 12.7645 15.0001 10.0012C15.0001 9.78173 14.9856 9.56173 14.9573 9.344L2.7778 15.5495V14.3023L17.2223 6.9456V8.19H17.2222ZM2.7778 13.0567V11.8083L3.3028 11.5405C3.70227 11.3372 3.9406 10.9133 3.90667 10.4661C3.89447 10.3122 3.88887 10.1566 3.88887 10.0011C3.88887 8.7116 4.29667 7.45493 5.0544 6.41107C7.0366 3.6794 10.8583 3.0722 13.5894 5.05493L13.4411 5.13047L12.4455 5.63767C11.7022 5.22267 10.8644 5.0038 10.0127 5.00267C7.2494 4.99933 5.0066 7.236 5.00273 9.99933C5.00273 10.2177 5.0172 10.436 5.04553 10.6527L17.2222 4.4488V5.6966L2.7778 13.0567Z",
    fill: "#0B213E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStellarLogo);
export default __webpack_public_path__ + "static/media/StellarLogo.7c7d0bd7ba8f5d5291b75fddf11aa112.svg";
export { ForwardRef as ReactComponent };